/* tslint:disable */
/* eslint-disable */
/**
 * Flawtrack Backend
 * Flawtrack ASM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TakedownEvent
 */
export interface TakedownEvent {
    /**
     * 
     * @type {number}
     * @memberof TakedownEvent
     */
    readonly id: number;
    /**
     * When this event occurred
     * @type {Date}
     * @memberof TakedownEvent
     */
    readonly eventDate: Date;
    /**
     * Description of the takedown action or progress
     * @type {string}
     * @memberof TakedownEvent
     */
    description: string;
    /**
     * 
     * @type {Date}
     * @memberof TakedownEvent
     */
    readonly createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof TakedownEvent
     */
    readonly updatedAt: Date;
}

/**
 * Check if a given object implements the TakedownEvent interface.
 */
export function instanceOfTakedownEvent(value: object): value is TakedownEvent {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('eventDate' in value) || value['eventDate'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function TakedownEventFromJSON(json: any): TakedownEvent {
    return TakedownEventFromJSONTyped(json, false);
}

export function TakedownEventFromJSONTyped(json: any, ignoreDiscriminator: boolean): TakedownEvent {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'eventDate': (new Date(json['event_date'])),
        'description': json['description'],
        'createdAt': (new Date(json['created_at'])),
        'updatedAt': (new Date(json['updated_at'])),
    };
}

  export function TakedownEventToJSON(json: any): TakedownEvent {
      return TakedownEventToJSONTyped(json, false);
  }

  export function TakedownEventToJSONTyped(value?: Omit<TakedownEvent, 'id'|'event_date'|'created_at'|'updated_at'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'description': value['description'],
    };
}

